import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPetFormTwoStart,
  postPetFormTwoSuccess,
  postPetFormTwoDataSuccess,
  postPetFormTwoFailure,
} from "../reducers/postPetFormTwoReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPetFormTwo = createAsyncThunk(
  "postPetFormTwo",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPetFormTwoStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/PetInsurance/SavePetDetails`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPetFormTwoSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postPetFormTwoDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPetFormTwoFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPetFormTwoFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPetFormTwoFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
